












































































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class SingleProduct extends Vue {
    productQuantity: number = 1

    editQuantity (operation: 'incr' | 'decr'): void {
        if (operation === 'incr') {
            this.productQuantity++
        }
        if (operation === 'decr' && this.productQuantity >= 2) {
            this.productQuantity--
        }
    }
}
